module.exports = __webpack_public_path__ + "static/media/hand.b0a73d9a.ico";